export const ALLOWED_ECOSYSTEM_MPID = ['SHC575', 'SHC576', 'SHC574', 'SHC589', 'SHC593', 'SHC004', 'SHC072'];
// Any prefix the host application may mount this remote under.
export const SUPPORTED_ZONE_PREFIXES = ['/matosinhos', '/algarve'];

export const STORAGE_PREFIX = "gbe_";

// export const ICIM_STATE = [{
//     "key": "isHosted",
//     "value": "true",
//     "state": "bookingEngine"
// }]

export const ICIM_STATE = (isHosted) => isHosted ==='true' ? "bookingEngine" : "";
export const showCrowdIndicator = false;

